import type { SectionProps } from "../../../../../components/Questionnaire/Section";
import type { Locale } from "../../../../../types";
import { perfMark, perfMeasure } from "../../../../../utils/performanceTiming";
import type { QuestionnaireState } from "../../../types";
import { flattenSections } from "../groups/flattenSections";
import { processQuestionnaire } from "./processQuestionnaire";

export const handleSetAction = (
  state: QuestionnaireState,
  payload: SectionProps[],
): QuestionnaireState => {
  perfMark("setAction:start");

  const { answers, config } = state;
  const locale = config?.locale as Locale | undefined;

  perfMark("flattenSections:start");
  const {
    sections: flattenedSections,
    answers: updatedAnswers,
    groups,
    visibility: groupChildrenVisibility,
    groupQuestionNames,
  } = flattenSections({ sections: payload, answers });
  perfMeasure("flattenSections", "flattenSections:start");

  perfMark("processQuestionnaire:start");
  const {
    sections,
    addressModes,
    visibility,
    answers: processedAnswers,
    serverErrors,
    firstIncompleteSection,
    firstSectionWithErrors,
  } = processQuestionnaire({
    flattenedSections,
    existingAnswers: updatedAnswers,
    groupChildrenVisibility,
    groupQuestionNames,
    locale,
  });
  perfMeasure("processQuestionnaire", "processQuestionnaire:start");

  perfMark("sectionsCheck:start");
  // Shallow check: preserve reference if section IDs and question counts match
  const sectionsUnchanged =
    state.sections.length === sections.length &&
    state.sections.every(
      (s, i) =>
        s.id === sections[i].id &&
        s.questions.length === sections[i].questions.length,
    );
  const sectionsToUse = sectionsUnchanged ? state.sections : sections;
  perfMeasure("sectionsCheck", "sectionsCheck:start");

  const currentSectionIndex = Math.min(
    firstSectionWithErrors ?? sections.length - 1,
    firstIncompleteSection ?? sections.length - 1,
  );

  perfMeasure("setAction:total", "setAction:start");

  return {
    ...state,
    sections: sectionsToUse,
    answers: processedAnswers,
    visibility,
    addressModes,
    groups,
    currentSectionIndex,
    errors: serverErrors,
  };
};
